module.exports = __webpack_public_path__ + "_assets/img/profile-10.7f7bf72c.svg";